import { autoinject } from 'aurelia-framework';
import { FeatureService } from '../../services/features-service';
import { requireServices } from '../../support/activation';

@autoinject
export class ContactsInfoScreen {
  constructor(private featureService: FeatureService) { }

  async canActivate() {
    await requireServices(this.featureService);
  }

}
